export default __webpack_public_path__ + "static/media/bg-img.350e1686.png";